(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('proofSearch', () => ({
      open: false,
      query: '',
      loading: false,
      results: [],
      _ctrl: null,

      toggle() {
        this.open = !this.open;
        if (this.open) this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
      },
      close() { this.open = false; },

      formatPrice(raw) {
        if (raw == null || raw === '') return '';
        // Already money-formatted (has a currency symbol / letters) — show as-is.
        if (typeof raw === 'string' && /[^\d.,\s]/.test(raw)) return raw;
        // Decimal string like "39.00" → cents for our money formatter.
        const cents = Math.round(parseFloat(String(raw).replace(',', '.')) * 100);
        return isNaN(cents) ? '' : window.PROOF.formatMoney(cents);
      },

      async run() {
        const q = this.query.trim();
        if (q.length < 2) { this.results = []; return; }
        this.loading = true;
        if (this._ctrl) this._ctrl.abort();
        this._ctrl = new AbortController();
        const base = (window.PROOF.routes && window.PROOF.routes.predictive_search) || '/search/suggest';
        const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
        try {
          const res = await fetch(url, { signal: this._ctrl.signal, headers: { 'Accept': 'application/json' } });
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          this.results = products.map((p) => ({
            id: p.id,
            title: p.title,
            url: p.url,
            image: p.featured_image ? p.featured_image.url : (p.image || null),
            price: this.formatPrice(p.price),
          }));
        } catch (e) {
          if (e.name !== 'AbortError') this.results = [];
        } finally {
          this.loading = false;
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('productForm', () => ({
      product: null,
      variant: null,
      options: [],
      qty: 1,
      error: '',

      init() {
        this.product = JSON.parse(this.$el.querySelector('[data-product-json]').textContent);
        const currentId = parseInt(this.$el.dataset.currentVariant, 10);
        this.variant = this.product.variants.find((v) => v.id === currentId) || this.product.variants[0];
        this.options = this.variant ? [...this.variant.options] : [];
      },

      get currentPrice() { return this.variant ? this.variant.price : 0; },
      get available() { return !!(this.variant && this.variant.available); },

      money(cents) { return window.PROOF.formatMoney(cents); },

      selectOption(index, value) {
        this.options[index] = value;
        this.resolveVariant();
      },

      resolveVariant() {
        const match = this.product.variants.find((v) =>
          v.options.every((opt, i) => opt === this.options[i])
        );
        if (match) {
          this.variant = match;
          this.error = '';
          this.updateUrl();
          this.$dispatch('variant:changed', { variant: match });
        } else {
          this.variant = { available: false, price: 0, options: this.options };
        }
      },

      updateUrl() {
        if (!this.variant.id || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url);
      },

      setQty(n) {
        const val = parseInt(n, 10);
        this.qty = isNaN(val) || val < 1 ? 1 : val;
      },

      async addToCart() {
        if (!this.available) return;
        this.error = '';
        try {
          await this.$store.cart.add({ id: this.variant.id, quantity: this.qty });
        } catch (e) {
          this.error = e.message;
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
